import { BRAND_NAME } from "./constants";

export async function initNativeApp() {
  const isNative = typeof window !== 'undefined' &&
    window.Capacitor &&
    window.Capacitor.isNativePlatform();
  if (!isNative) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0a1628' });
    await StatusBar.show();
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: 300 });
    const { Keyboard } = await import('@capacitor/keyboard');
    Keyboard.setAccessoryBarVisible({ isVisible: false });
    const { App } = await import('@capacitor/app');
    App.addListener('backButton', ({ canGoBack }) => {
      if (!canGoBack) {
        if (window.confirm(`Exit ${BRAND_NAME}?`)) App.exitApp();
      } else {
        window.history.back();
      }
    });
  } catch (e) {
    console.warn('Native init error:', e);
  }
}
